import { render, staticRenderFns } from "./shareProfit.vue?vue&type=template&id=77d6c0f1&"
import script from "./shareProfit.vue?vue&type=script&lang=js&"
export * from "./shareProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports